export default __webpack_public_path__ + "static/123-min-min-9c1f5ebcb397d3509b17fc93dcf4a201.jpg";